/*
 * @Author: 周立伟 1508761480@qq.com
 * @Date: 2022-09-08 15:34:59
 * @LastEditors: 周立伟 1508761480@qq.com
 * @LastEditTime: 2022-09-27 21:37:26
 * @FilePath: \login\modes\src\router\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import { lazy } from "react";
// import { Navigate } from "react-router-dom";
// const Layout = lazy(() => import("../pages/Layout"));
// const Login = lazy(() => import("../pages/Login"));
// const Ga = lazy(() => import("../pages/ga"))
// const Safetytraining = lazy(() => import("../pages/ga/safetytraining"))
// const Report = lazy(() => import("../pages/ga/safetytraining/report"))
// const Statistics = lazy(() => import("../pages/ga/safetytraining/statistics"))
// const TestDeclare = lazy(() => import("../pages/ga/safetytraining/testDeclare"))
// const TestPlan = lazy(() => import("../pages/ga/safetytraining/testPlan"))
// const Training = lazy(() => import("../pages/ga/safetytraining/training"))

// const RouterList = [
//   {
//     path: "/Layout",
//     element: <Layout />,
//     children: [
//       {
//         path: "/Layout",
//         element: <Navigate to="/Layout/Housing" />,
//       },
//     ],
//   },
//   {
//     path: "/",
//     element: <Login />,
//   }, {
//     path: '/ga',
//     element: <Ga />,
//     children: [
//       {
//         path: '/safetytraining',
//         element: <Safetytraining />,
//         children: [
//           {
//             path: '/report',
//             element: <Report />,
//           }, {
//             path: '/statistics',
//             element: <Statistics />,
//           }, {
//             path: '/testDeclare',
//             element: <TestDeclare />,
//           }, {
//             path: '/testPlan',
//             element: <TestPlan />,
//           }, {
//             path: '/training',
//             element: <Training />,
//           }
//         ]
//       }
//     ]
//   }
// ];

// export default RouterList;


import {Route,Routes,Navigate,BrowserRouter, } from 'react-router-dom'
import {Suspense} from 'react'
import routes from './routes'
import './index.css'
const Router=()=>{
    const renderlist=(routes)=>{
        return routes.map((item,index)=>{
            return item.path?<Route key={index} path={item.path} element={item.element}>
                {
                    item.children&&renderlist(item.children)
                }
            </Route>:<Route key={index} path={item.from} element={<Navigate to={item.to}/>}></Route>
        })
    }
    return <Suspense fallback={<img className='img' src='https://img.zcool.cn/community/012b3c599276cc0000002129ebff53.gif'/>}>
        <BrowserRouter>
            <Routes>
                {
                    renderlist(routes)
                }
            </Routes>
        </BrowserRouter>
    </Suspense>
}
export default Router